import React from 'react';
import { CircularProgress, TableCell } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

// Reusable action buttons component for handling tick and cross actions
export const ActionButtons = ({
  rowId,
  imageKey,
  sku,
  processingRows,
  onTickClick,
  onCrossClick
}) => {
  const isProcessing = processingRows.tick || processingRows.cross;
  
  return (
    <>
      <TableCell>
        {processingRows.tick === rowId ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          <CheckIcon
            sx={{ 
              color: isProcessing ? '#bdbdbd' : 'primary.main',
              fontSize: 28, 
              cursor: isProcessing ? 'default' : 'pointer'
            }}
            onClick={() => {
              if (!isProcessing) {
                onTickClick(imageKey, sku, rowId);
              }
            }}
          />
        )}
      </TableCell>
      <TableCell>
        {processingRows.cross === rowId ? (
          <CircularProgress size={24} color="error" />
        ) : (
          <CloseIcon
            sx={{ 
              color: isProcessing ? '#bdbdbd' : 'error.main',
              fontSize: 28, 
              cursor: isProcessing ? 'default' : 'pointer'
            }}
            onClick={() => {
              if (!isProcessing) {
                onCrossClick(imageKey, sku, rowId);
              }
            }}
          />
        )}
      </TableCell>
    </>
  );
};
